// components/Contact.js

function Contact() {
  return (
    <section className="contact-section" id="contact">
      <div className="contact-content">

        <div className="contact-header">
          <div className="contact-eyebrow">Reach Us</div>
          <h2>Get in <span>Touch</span></h2>
          <p>Reach out to the Media &amp; Community Relations Centre — we'd love to hear from you</p>
        </div>

        <div className="contact-compact">

          {/* Left — Info Panel */}
          <div className="contact-info-side">

            <div className="contact-info-top">
              <h3>Contact Information</h3>
              <p className="contact-intro">
                Open Monday – Friday, 8:30 AM – 4:30 PM. Feel free to reach us
                through any of the following channels.
              </p>
            </div>

            <div className="c-details-list">

              <div className="c-detail">
                <div className="c-detail-icon">&#128205;</div>
                <div className="c-detail-text">
                  <h5>Location</h5>
                  <p>Media &amp; Community Relations Centre,</p>
                  <p>University of Peradeniya,</p>
                  <p>P.O. Box 20400, Sri Lanka</p>
                </div>
              </div>

              <div className="c-detail">
                <div className="c-detail-icon">&#128222;</div>
                <div className="c-detail-text">
                  <h5>Phone</h5>
                  <a href="tel:+94812392329">+94 81 239 2329</a>
                  <p>Extension: 2329</p>
                </div>
              </div>

              <div className="c-detail">
                <div className="c-detail-icon">&#9993;</div>
                <div className="c-detail-text">
                  <h5>Email</h5>
                  <a href="mailto:mcrc@gs.pdn.ac.lk">mcrc@gs.pdn.ac.lk</a>
                  <a href="mailto:webmaster@pdn.ac.lk">webmaster@pdn.ac.lk</a>
                </div>
              </div>

            </div>

          </div>

          {/* Right — Google Map */}
          <div className="contact-map-side">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d15913.960336755572!2d80.58884549901003!3d7.256636193257563!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1suniversity%20of%20peradeniya!5e0!3m2!1sen!2slk!4v1768193867280!5m2!1sen!2slk"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="University of Peradeniya Map"
            ></iframe>
          </div>

        </div>
      </div>
    </section>
  );
}

export default Contact;